import React from 'react';
import { RenderEmail } from '../renders';

const TableRenderEmail = column => rowData => (
  <RenderEmail value={rowData[column]} />
);

export default TableRenderEmail;
